import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalysisComponent } from 'app/analysis/analysis.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionPlanComponent } from 'app/actionplan/actionplan.component';
import { AddAuditerComponent } from 'app/add-auditer/add-auditer.component';
import { AddGmComponent } from 'app/add-gm/add-gm.component';
import { AddAssignUserComponent } from 'app/addassignuser/addassignuser.component';
import { DownloadsComponent } from 'app/downloads/downloads.component';
import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReportsComponent } from 'app/reports/reports.component';
// import {GeneralService} from '../../../../services/general.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxGaugeModule } from 'ngx-gauge';
import { ModuelsDetailsComponent } from 'app/dashboard/ModuelsDetails/ModuelsDetails.component';
import { AddCeoComponent } from 'app/add-ceo/add-ceo.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ChangePasswordComponent } from 'app/ChangePassword/ChangePassword.component';
import { TestResultsComponent } from 'app/TestResults/TestResults.component';
import { LabReportsComponent } from 'app/LabReports/LabReports.component';
import {AddusermeasurerComponent} from 'app/addusermeasurer/addusermeasurer.component';
import {AddmeasureitemsComponent} from 'app/addmeasureitems/addmeasureitems.component';
import {MeasurerReportsComponent} from 'app/measurer-reports/measurer-reports.component';
import { MeasurerdashboardComponent } from 'app/measurerdashboard/measurerdashboard.component';
import { LowercaseInputDirective } from 'app/lowercase-input.directive';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ChatAiComponent } from 'app/ChatAi/ChatAi/ChatAi.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MonitiringDashboardComponent } from 'app/monitiring-dashboard/monitiring-dashboard.component';
import { AddModuleComponent } from 'app/add-module/add-module.component';
import { GeneralService } from 'app/services/general.service';


@NgModule({
 
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatTooltipModule,
    MatRadioModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatBadgeModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxGaugeModule,
    FormsModule,
    NgSelectModule,
    MatButtonToggleModule,
    MatTabsModule,
    TableModule,
    MatCardModule,
    ButtonModule    ,
    MatCheckboxModule
  ],
  declarations: [
    AnalysisComponent,
    ReportsComponent,
    DownloadsComponent,
    ActionPlanComponent,
    AddAssignUserComponent,
    AddCeoComponent,
    AddGmComponent,
    TestResultsComponent,
    LabReportsComponent,
    AddAuditerComponent,
    AddAssignUserComponent,
    DashboardComponent,
    ModuelsDetailsComponent,
  AddmeasureitemsComponent,
  AddusermeasurerComponent,
  MeasurerReportsComponent,
  MonitiringDashboardComponent,
  MeasurerdashboardComponent,
  LowercaseInputDirective,
  AddModuleComponent,
      ChatAiComponent,
  
    ], 
     providers: [GeneralService,{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }]
})
export class SharedModule { 


}
